



















import Vue from 'vue'
import NewPilotButton from './NewPilotButton.vue'
import FileImport from './add_panels/FileImport.vue'
import CloudImport from './add_panels/CloudImport.vue'

export default Vue.extend({
  name: 'add-pilot',
  components: { FileImport, CloudImport, NewPilotButton },
})
